import React from 'react';
import { Field } from 'redux-form';
import { FormControl, FormFieldLabel, ReduxFormFieldRenderInput } from 'components';
import { isCompanyTypePersonal } from 'helpers/currentCompany';
import { requiredValidator } from 'helpers/fieldValidation';
const PartnerCompanyBillingForm = ({ companyType, hideLabel }) => {
    if (isCompanyTypePersonal(companyType)) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        !hideLabel && React.createElement(FormFieldLabel, null, "Entity info"),
        React.createElement(FormControl, null,
            React.createElement(Field, { component: ReduxFormFieldRenderInput, name: "company.name", props: { className: 'w-full', placeholder: 'Legal company name', type: 'text' }, validate: requiredValidator }))));
};
export default PartnerCompanyBillingForm;
